import React, { useContext, useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { useSettingModal } from '../../../../hooks/Context';
import {FaGlobeAmericas as UIcon} from 'react-icons/fa';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import { useDispatch } from 'react-redux';
import { addAdminUser } from '../../../../redux/reducers/adminUserReducer';
import {Waiting,CreateAdminUser as Create} from '../Modal';
import { config } from '../../../../api';
import apiCall from '../../../../utils/apiCall';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { NotificationContext } from '../../../../providers/notification';
import { AxiosError } from 'axios';

interface Routes {
  RouteName: string;
  RouteId: number;
};

interface RouteData {
  Data: Routes[];
};

interface RoutesResponse {
  data: RouteData;
};

interface RouteResponseData {
  Id:string;
  Name:string;
  NormalizeName:string;

}

type RoutesResponseArray = RouteResponseData[]

interface Payload {
  Email: string;
  FirstName: string;
  LastName: string;
  PhoneNumber: string;
  RoleName: RoleName[];
  RouteId: number;
};

interface UpdatePayload {
  Id: string;
  FirstName: string;
  LastName: string;
  PhoneNumber: string;
};

interface RoleName {
  RoleName: string;
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const CreateAdminUser = (props:any) => {// This is component using it.
  const {setShowModal, setModalContent, setShowCancel} = useSettingModal();
  const [userRole, setUserRole] = useState<string[]>(props?.update && props.update.RoleList?.Roles?props.update.RoleList.Roles:[]);
  const [email, setEmail] = useState<string>('');
  const [phoneNumber, setPhoneNumber] = useState<string>('');
  const [firstName, setFirstName] = useState<string>('');
  const [lastName, setLastName] = useState<string>('');
  const [disabled,setDisabled] = useState<boolean>(false);
  const [userRoute, setUserRoute] = useState<string>('');
  const [id ,setId] = useState('');
 
  // const roleData = props.roleData;
  const update = props.update;
  const mode = props.mode
  
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { showNotification } = useContext(NotificationContext);

  const handleChange = (event: SelectChangeEvent<typeof userRole>) => {
    const {
      target: { value },
    } = event;
    setUserRole(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const getAllRoutes = async (): Promise<RoutesResponse> => {
    return (await apiCall().get('/Routes/GetAllRoute'))
  };
  const getAllRoles = async (): Promise<RoutesResponse> => {
    return (await apiCall().get('/Administration/roles/readall'));
  };
  

  const { data, isLoading, error, isError } = useQuery(['get-all-routes'], getAllRoutes, {
    retry: 0,
    keepPreviousData: true,
    enabled: true,
  });

  const { data:role_d, isLoading:role_loading} = useQuery(['get-all-roles'], getAllRoles, {
    retry: 0,
    keepPreviousData: true,
    enabled: true,
  });

  const routeData = data?.data?.Data;
  const roleData:any = role_d?.data || [];
  const getAllRoutesError = error as AxiosError;
  const getAllRoutesErrorMessage = getAllRoutesError?.message;

  //your code should be here.
  const clearForm = () => {
    setFirstName('');
    setUserRole([]);
    setLastName('');
    setPhoneNumber('');
    setEmail('');
  };

  const createAdminUser = async (data: Payload) => {
    return (await apiCall().post('/Administration/post/registerByAdmin/user', data));
  };

  const createAdminUserMutation = useMutation(['create-admin-user'], createAdminUser, {retry: 0});

  const createAdminUserHandler = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const roleArray = userRole.map((eRole) => ({RoleName: eRole}));

    const payload: Payload = {
      FirstName: firstName,
      LastName: lastName,
      Email: email,
      PhoneNumber: phoneNumber,
      RoleName: roleArray,
      RouteId: 1,
    };

    try {
      await createAdminUserMutation.mutateAsync(payload, {
        onSuccess: () => {
          showNotification({
            type: 'success',
            message: 'Admin User Successfully Created',
          })
          clearForm();
          setShowModal(false);
          queryClient.refetchQueries(['get-admin-users'])
        }
      })
    }catch(error: any) {
      showNotification({
        type: 'error',
        message: error?.response?.data?.Message || error?.message || 'You cannot create an Admin User',
      })
    }
  };

  const updateAdminUser = async (data: UpdatePayload) => {
    return (await apiCall().put('/Administration/post/updateAdminUser/adminUserUpdate', data));
  };

  const updateAdminUserMutation = useMutation(['update-admin-user'], updateAdminUser, {retry: 0});

  const updateAdminUserHandler = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    //const roleArray = userRole.map((eRole) => ({RoleName: eRole}));

    const payload: UpdatePayload = {
      Id: id,
      FirstName: firstName,
      LastName: lastName,
      PhoneNumber: phoneNumber,
    };

    try {
      await updateAdminUserMutation.mutateAsync(payload, {
        onSuccess: () => {
          showNotification({
            type: 'success',
            message: 'Admin User Successfully updated',
          })
          clearForm();
          setShowModal(false);
          queryClient.refetchQueries(['get-admin-users'])
        }
      })
    }catch(error: any) {
      showNotification({
        type: 'error',
        message: error?.response?.data?.Message || error?.message || 'You cannot Update an Admin User',
      })
    }
  };

  useEffect(() => {
    if(update && Object.keys(update).length > 0){
      setFirstName(update.FirstName);
      setLastName(update.LastName);
      setEmail(update.Email); 
      setPhoneNumber(update.PhoneNumber);
      setId(update.UserId);
    }
  }, [update]);

  useEffect(()=>{
    if(update && routeData && routeData.length > 0){
      let route = routeData.filter((eData:any)=>eData.RouteId == update.RuoteId);
      if(route.length > 0){
        setUserRoute(route[0].RouteName || '');
      }
    }
  },[update,routeData]);

  return (
    <ModalContainer>
      <div>
        <div>
          <div>
            <IconContainer><UIcon /></IconContainer>
            {
              mode === 'update' ?
              <span>Update Admin Users</span> :
              <span>Create Admin Users</span>
            }
          </div>
        </div>
        <MainContentContainer1 onSubmit={mode === 'update' ? updateAdminUserHandler : createAdminUserHandler }>
          <StyleLabel>
            <span>First Name</span>
            <StyleInput type="text" required placeholder='First Name' value={firstName} onChange={(e: any) => setFirstName(e.target.value)} />
          </StyleLabel>
          <StyleLabel>
            <span>Surname</span>
            <StyleInput type="text" required placeholder='Surname' value={lastName} onChange={(e: any) => setLastName(e.target.value)} />
          </StyleLabel>
          <StyleLabel>
            <span>Email Address</span>
            <StyleInput disabled = {mode === 'update' ? true: false} type="email" required placeholder='Email Address' value={email} onChange={(e) => setEmail(e.target.value)} />
          </StyleLabel>
          <StyleLabel>
            <span>Phone Number</span>
            <StyleInput type="text" required placeholder='Phone Number' value={phoneNumber} onChange={(e: any) => setPhoneNumber(e.target.value)}/>
          </StyleLabel>
          <StyleLabel>
            <span>Role</span>
            <Select
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              multiple
              disabled = {mode === 'update' ? true: false}
              value={userRole}
              onChange={handleChange}
              input={<OutlinedInput label="Role" />}
              renderValue={(selected) => selected.join(', ')}
              MenuProps={MenuProps}
            >
              {roleData?.length > 0 && roleData.map((role:any, index: number) => (
                <MenuItem key={index} value={role?.Name}>
                  <Checkbox checked={userRole.indexOf(role?.Name) > -1} />
                  <ListItemText primary={role?.Name} />
                </MenuItem>
              ))}
            </Select>
          </StyleLabel>
          {/* <StyleLabel>
            <span>Route</span>
            <Select
              value={userRoute}
              onChange={(e: SelectChangeEvent) => setUserRoute(e.target.value)}
              MenuProps={MenuProps}
              id="user-route-select"
              label="route"
            >
              {routeData?.map((route: Routes) => (
                <MenuItem key={route?.RouteId} value={route?.RouteName}>
                  {route?.RouteName}
                </MenuItem>
              ))}

            </Select>
          </StyleLabel> */}
         
          <SubmitContainer>
            <span style={{cursor:"pointer"}} onClick={() => setShowModal(false)}>Cancel</span>
            {!update ? <StyleButton disabled={createAdminUserMutation.isLoading} type="submit">
              {createAdminUserMutation.isLoading ? 'Submitting...' : 'Submit'}
            </StyleButton> :
            <StyleButton type="submit" disabled={createAdminUserMutation.isLoading}>
              Edit
          </StyleButton>}
          </SubmitContainer>
      
        </MainContentContainer1>
      </div>
    </ModalContainer>
  )
}

export default CreateAdminUser;

export const ModalContainer = styled.div`
  position: relative;
  width: 712px;
  height: fit-content;
  background-color: white;
  border-radius: 10px;
  & > div{
    width:100%;
    display: flex;
    flex-direction: column;
  }
  & > div > div:first-of-type{
    width:100%;
    display: flex;
    justify-content: space-between;
    padding:25px;
    background-color: #20BB70;
  }  

  & > div > div:first-of-type > div{
    display: flex;
    color:white;
    align-items: center;
    gap:15px;
  }  
`

export const StyleLabel = styled.label`
  display: flex;
  flex-direction: column;
  gap:5px;
  & div{
    width:100% !important;
  }
  & > span{
    font-size:13px;
  }

`

export const MainContentContainer1 = styled.form`
  display: flex;
  justify-content: space-between;
  width:100%;
  background-color:#fff;
  padding:25px;
    row-gap: 20px;;
  flex-wrap: wrap;
  & > label{
    width:45%;
    /* border:1px solid red; */
  }
  & >label.full{
    width:100%;
  }
    


`

export const StyleInput = styled.input`
   width:100%;
   border:1px solid #E1E1E1;
   font-size:13px;
   padding:15px;
   border-radius: 5px;
   outline-color:transparent;


`
export {UIcon};
export const IconContainer = styled.span`
    width:50px;
    height: 50px;
    background-color: #199056;
    color:white;
    justify-content: center;
    align-items: center;
    display: flex;
    border-radius: 5px;

`

export const SubmitContainer = styled.div`
    width:100%;
    display:flex;
    justify-content: flex-end;
    align-items:center;
    gap:20px;
    padding:10px 0;
    & > span{
      cursor: pointer;
    }
`
export const StyleButton = styled.button`
    padding:13px 25px;
    border-radius: 5px;
    color:#fff;
    background-color: #11643C;
    border:none;
    outline:none;
    cursor: pointer;

`